// removed by extract-text-webpack-plugin
module.exports = {"vitrade-textarea":"vitrade-textarea","form-control":"form-control"};


//////////////////
// WEBPACK FOOTER
// ./components/danangtrade-forms/common/_textarea.scss
// module id = ./components/danangtrade-forms/common/_textarea.scss
// module chunks = 0